import { useEffect, useState } from 'react';
import { find } from 'lodash';
import MuiTabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import { Activity_Type } from '@occc/graphql';

// TODO: update 'any' with more specific types
type LocationLogActivityTabsProps = {
  children: any;
  onChange: (value: Activity_Type) => void;
  tabs: any[];
  activeTabValue: Activity_Type;
};

export const Tabs = (props: LocationLogActivityTabsProps) => {
  const { activeTabValue, onChange, tabs, children } = props;
  const [activeTabState, setActiveTabState] = useState<Activity_Type>(activeTabValue);

  const handleChange = (_event: React.SyntheticEvent<Element, Event>, value: Activity_Type) => {
    setActiveTabState(value);
  };

  useEffect(() => {
    if (onChange) {
      onChange(activeTabState);
    }
  }, [activeTabState, onChange]);

  const tabsComponent = (
    <MuiTabs value={activeTabState} onChange={handleChange} indicatorColor='primary'>
      {Array.isArray(tabs) &&
        tabs.map((tab) => <Tab key={tab.value} label={tab.label} value={tab.value} />)}
    </MuiTabs>
  );

  const activeTab = Array.isArray(tabs) ? find(tabs, (tab) => tab.value === activeTabState) : null;

  if (activeTab) {
    const { content, ...rest } = activeTab;
    return children(tabsComponent, content, rest);
  }

  return children(tabsComponent);
};
